export default {"src":"/_next/static/media/repair-fill.8cf256ea.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};